"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.for-each");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * Helper: Event bus
 * -----------------------------------------------------------------------------
 * A global event dispatcher used to communicate between components.
 *
 * @namespace eventBus
 */


var _default = function _default() {
  /**
   * Create a new EventBus instance.
   */
  var eventBus = {};
  /**
   * Listen for the given event.
   * @param {string|Array} events - Event string. eg: Namespace:state.
   * @param {Function} handler - Callback function to execute when event is fired.
   */

  function listen(events, handler) {
    _toConsumableArray([].concat(events)).forEach(function (event) {
      eventBus[event] = (eventBus[event] || []).concat(handler);
    });

    return this;
  }
  /**
   * Trigger all handlers for the given event.
   * @param {string} event - Event string. eg: Namespace:state.
   * @param {*} data - Payload to send to listeners.
   */


  function emit(event, data) {
    if (!eventBus[event]) {
      return false;
    }

    return _toConsumableArray(eventBus[event]).forEach(function (handler) {
      return handler(data);
    });
  }
  /**
   * Fetch all registered event listeners.
   */


  function all() {
    return eventBus;
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    listen: listen,
    emit: emit,
    all: all
  });
};

exports["default"] = _default;